var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.from)?_c('div',{staticClass:"localinfoMap"},[_c('GmapMap',{ref:"map",staticStyle:{"width":"100%","height":"100%"},attrs:{"center":{
      lat: _vm.center.lat,
      lng: _vm.center.lng
    },"zoom":_vm.zoom}},[_c('GmapMarker',{attrs:{"position":{
        lat: _vm.from.lat,
        lng: _vm.from.lng},"icon":{
        url: _vm.iconUrl.hotel,
        scaledSize: _vm.iconSize
      }}}),(_vm.location && _vm.location !== null)?_c('GmapMarker',{attrs:{"position":{
        lat: _vm.location.geometry.location.lat,
        lng: _vm.location.geometry.location.lng},"icon":{
        url: _vm.iconUrl.place,
        scaledSize: _vm.iconSize
      }}}):_vm._e(),(_vm.search && _vm.search !== null)?_c('GmapInfoWindow',{attrs:{"position":{
        lat: _vm.search.lat,
        lng: _vm.search.lng}}},[_c('div',{staticClass:"placeInfo"},[_c('p',{staticClass:"name mb5"},[_c('img',{attrs:{"src":_vm.search.icon,"alt":""}}),_vm._v(" "+_vm._s(_vm.search.name)+" ")]),_c('p',{staticClass:"address mb10"},[_vm._v(_vm._s(_vm.search.address))]),_c('button',{staticClass:"btn btnPrimary btnFull",attrs:{"type":"button"},on:{"click":_vm.onCreate}},[_vm._v(_vm._s(_vm.locale.localinfo_registration))])])]):_vm._e()],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }